import { ellipsis } from "@/common/style/commonStyle";
import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

export const useStyle = makeStyles({
	avatarContainer: {
		...shorthands.padding(0, "16px", "16px", "16px"),
	},
	avatar: {
		color: tokens.colorNeutralForeground1Static,
	},
	userBasicsContainer: {
		fontSize: tokens.fontSizeBase300,
		maxWidth: "140px",
	},
	userName: {
		fontWeight: tokens.fontWeightSemibold,
		lineHeight: "18px",
		...ellipsis(),
	},
	userJobTitle: {
		lineHeight: "18px",
		height: "18px",
		...ellipsis(),
		color: tokens.colorNeutralForeground3,
	},
	userStatus: {
		lineHeight: "18px",
		display: "flex",
		alignItems: "flex-end",
		color: tokens.colorNeutralForeground3,
	},
	statusName: {
		paddingRight: "4px",
		maxWidth: "140px",
		...ellipsis(),
	},
	presenceBadgeIcon: {
		...shorthands.padding(0, "8px", 0, 0),
		backgroundColor: tokens.colorTransparentBackground,
	},
	isNotJoinedBorder: {
		border: `2px solid ${tokens.colorPaletteRedBackground3}`,
	},
});
